export enum HOME_PAGE_SECTION_NAME_ENUM {
  NEW_PRODUCT_SECTION = "hp_new_product_section",
  FLASH_DEAL_SECTION = "hp_flash_deal_section",
  BEST_SELLER_SECTION = "hp_best_seller_section",
  COFFEE_MATCHA_HOT_DRINK = "hp_coffee_section",
  BLACK_MILK_TEA_SECTION =  "hp_black_milk_tea_section",
  OOLONG_MILK_TEA_SECTION= "hp_oolong_milk_tea_section",
  SEASON_DRINKS_SECTION = "hp_section_drinks",
  FRESH_FRUIT_JUICE_SECTION = "hp_fresh_fruit_juice_section",
  NON_CAFFEIN_SECTION = "hp_non_caffein_section",
  SMOOTHIE_SECTION = "hp_smoothie_section"
}
